export default "__VITE_ASSET___hRhl46e__"